import { useState, useEffect } from 'react';
import apiService from '../services/apiService';

const useReceivables = (currentPage = 1, currentPageLimit = 100, refreshKey) => {
  const [receivables, setReceivables] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReceivables = async () => {
      setLoading(true);
      try {
        const response = await apiService.getReceivables(currentPage, currentPageLimit);
        const data = response?.data || response;
        const { items = [], total_pages = 1, total_items = 0 } = data;
        setReceivables(items || []);
        setTotalPages(total_pages || 1);
        setTotalItems(total_items || 0);
        setError(null);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Error fetching receivables');
      } finally {
        setLoading(false);
      }
    };
    fetchReceivables();
  }, [currentPage, currentPageLimit, refreshKey]);

  return { receivables, totalPages, totalItems, loading, error };
};

export default useReceivables;
